var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhotovoltaiquePanelH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 51,
    viewBox: "0 0 85 51",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_382_1915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 43.5935L8.10053 49.594L7.10413 50.5996H1.09692L0.100529 49.594L0.100342 43.5935L1.09674 42.5996H7.10395L8.10034 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 48.6235L0.100529 48.7404H8.10053V48.6235H0.100529Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 44.4471L0.100342 44.5641H8.10034V44.4471H0.100342Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 35.0935L8.10053 41.094L7.10413 42.0996H1.09692L0.100529 41.094L0.100342 35.0935L1.09674 34.0996H7.10395L8.10034 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 40.1235L0.100529 40.2404H8.10053V40.1235H0.100529Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 35.9471L0.100342 36.0641H8.10034V35.9471H0.100342Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 26.5935L8.10053 32.594L7.10413 33.5996H1.09692L0.100529 32.594L0.100342 26.5935L1.09674 25.5996L7.10395 25.5996L8.10034 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 31.6235L0.100529 31.7404L8.10053 31.7404V31.6235L0.100529 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 27.4471L0.100342 27.5641L8.10034 27.5641V27.4471L0.100342 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 18.0935L8.10053 24.094L7.10413 25.0996L1.09692 25.0996L0.100529 24.094L0.100342 18.0935L1.09674 17.0996L7.10395 17.0996L8.10034 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 23.1235L0.100529 23.2404L8.10053 23.2404V23.1235L0.100529 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 18.9471L0.100342 19.0641L8.10034 19.0641V18.9471L0.100342 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 9.59353L8.10053 15.594L7.10413 16.5996L1.09692 16.5996L0.100529 15.594L0.100342 9.59353L1.09674 8.59961L7.10395 8.59961L8.10034 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 14.6235L0.100529 14.7404L8.10053 14.7404V14.6235L0.100529 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 10.4471L0.100342 10.5641L8.10034 10.5641V10.4471L0.100342 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10034 1.09353L8.10053 7.094L7.10413 8.09961L1.09692 8.09961L0.100529 7.094L0.100342 1.09353L1.09674 0.0996094L7.10395 0.0996094L8.10034 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100529 6.12346L0.100529 6.24039L8.10053 6.24039V6.12346L0.100529 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100342 1.94713L0.100342 2.06406L8.10034 2.06406V1.94713L0.100342 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 43.5935L16.6005 49.594L15.6041 50.5996L9.59692 50.5996L8.60053 49.594L8.60034 43.5935L9.59674 42.5996L15.6039 42.5996L16.6003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 48.6235V48.7404L16.6005 48.7404V48.6235L8.60053 48.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 44.4471V44.5641L16.6003 44.5641V44.4471L8.60034 44.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 35.0935L16.6005 41.094L15.6041 42.0996L9.59692 42.0996L8.60053 41.094L8.60034 35.0935L9.59674 34.0996L15.6039 34.0996L16.6003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 40.1235V40.2404L16.6005 40.2404V40.1235L8.60053 40.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 35.9471V36.0641L16.6003 36.0641V35.9471L8.60034 35.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 26.5935L16.6005 32.594L15.6041 33.5996L9.59692 33.5996L8.60053 32.594L8.60034 26.5935L9.59674 25.5996L15.6039 25.5996L16.6003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 31.6235V31.7404L16.6005 31.7404V31.6235L8.60053 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 27.4471L8.60034 27.5641L16.6003 27.5641V27.4471L8.60034 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 18.0935L16.6005 24.094L15.6041 25.0996L9.59692 25.0996L8.60053 24.094L8.60034 18.0935L9.59674 17.0996L15.6039 17.0996L16.6003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 23.1235V23.2404L16.6005 23.2404V23.1235L8.60053 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 18.9471V19.0641L16.6003 19.0641V18.9471L8.60034 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 9.59353L16.6005 15.594L15.6041 16.5996L9.59692 16.5996L8.60053 15.594L8.60034 9.59353L9.59674 8.59961L15.6039 8.59961L16.6003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 14.6235V14.7404L16.6005 14.7404V14.6235L8.60053 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 10.4471V10.5641L16.6003 10.5641V10.4471L8.60034 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 1.09353L16.6005 7.094L15.6041 8.09961L9.59692 8.09961L8.60053 7.094L8.60034 1.09353L9.59674 0.0996095L15.6039 0.0996095L16.6003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60053 6.12346V6.24039L16.6005 6.2404V6.12346L8.60053 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60034 1.94713V2.06406L16.6003 2.06406V1.94713L8.60034 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 43.5935L25.1005 49.594L24.1041 50.5996H18.0969L17.1005 49.594L17.1003 43.5935L18.0967 42.5996H24.1039L25.1003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 48.6235V48.7404H25.1005V48.6235H17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 44.4471V44.5641H25.1003V44.4471H17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 35.0935L25.1005 41.094L24.1041 42.0996H18.0969L17.1005 41.094L17.1003 35.0935L18.0967 34.0996H24.1039L25.1003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 40.1235V40.2404H25.1005V40.1235H17.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 35.9471V36.0641H25.1003V35.9471H17.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 26.5935L25.1005 32.594L24.1041 33.5996H18.0969L17.1005 32.594L17.1003 26.5935L18.0967 25.5996H24.1039L25.1003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 31.6235V31.7404L25.1005 31.7404V31.6235L17.1005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 27.4471V27.5641L25.1003 27.5641V27.4471L17.1003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 18.0935L25.1005 24.094L24.1041 25.0996H18.0969L17.1005 24.094L17.1003 18.0935L18.0967 17.0996H24.1039L25.1003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 23.1235V23.2404L25.1005 23.2404V23.1235L17.1005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 18.9471V19.0641L25.1003 19.0641V18.9471L17.1003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 9.59353L25.1005 15.594L24.1041 16.5996H18.0969L17.1005 15.594L17.1003 9.59353L18.0967 8.59961L24.1039 8.59961L25.1003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 14.6235V14.7404L25.1005 14.7404V14.6235L17.1005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 10.4471V10.5641L25.1003 10.5641V10.4471L17.1003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1003 1.09353L25.1005 7.094L24.1041 8.09961L18.0969 8.09961L17.1005 7.094L17.1003 1.09353L18.0967 0.0996096L24.1039 0.0996096L25.1003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1005 6.12346V6.2404L25.1005 6.2404V6.12346L17.1005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1003 1.94713V2.06406L25.1003 2.06406V1.94713L17.1003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 43.5935L33.6005 49.594L32.6041 50.5996L26.5969 50.5996L25.6005 49.594L25.6003 43.5935L26.5967 42.5996L32.6039 42.5996L33.6003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 48.6235V48.7404L33.6005 48.7404V48.6235L25.6005 48.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 44.4471V44.5641L33.6003 44.5641V44.4471L25.6003 44.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 35.0935L33.6005 41.094L32.6041 42.0996L26.5969 42.0996L25.6005 41.094L25.6003 35.0935L26.5967 34.0996L32.6039 34.0996L33.6003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 40.1235V40.2404L33.6005 40.2404V40.1235L25.6005 40.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 35.9471V36.0641L33.6003 36.0641V35.9471L25.6003 35.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 26.5935L33.6005 32.594L32.6041 33.5996L26.5969 33.5996L25.6005 32.594L25.6003 26.5935L26.5967 25.5996H32.6039L33.6003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 31.6235V31.7404H33.6005V31.6235L25.6005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 27.4471V27.5641H33.6003V27.4471H25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 18.0935L33.6005 24.094L32.6041 25.0996H26.5969L25.6005 24.094L25.6003 18.0935L26.5967 17.0996H32.6039L33.6003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 23.1235V23.2404H33.6005V23.1235H25.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 18.9471V19.0641H33.6003V18.9471H25.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 9.59353L33.6005 15.594L32.6041 16.5996H26.5969L25.6005 15.594L25.6003 9.59353L26.5967 8.59961L32.6039 8.59961L33.6003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 14.6235V14.7404L33.6005 14.7404V14.6235L25.6005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 10.4471V10.5641L33.6003 10.5641V10.4471L25.6003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6003 1.09353L33.6005 7.094L32.6041 8.09961L26.5969 8.09961L25.6005 7.094L25.6003 1.09353L26.5967 0.0996097L32.6039 0.0996098L33.6003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6005 6.12346V6.2404L33.6005 6.2404V6.12346L25.6005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6003 1.94713V2.06406L33.6003 2.06406V1.94713L25.6003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 43.5935L42.1005 49.594L41.1041 50.5996H35.0969L34.1005 49.594L34.1003 43.5935L35.0967 42.5996H41.1039L42.1003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 48.6235V48.7404H42.1005V48.6235H34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 44.4471V44.5641H42.1003V44.4471H34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 35.0935L42.1005 41.094L41.1041 42.0996H35.0969L34.1005 41.094L34.1003 35.0935L35.0967 34.0996H41.104L42.1003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 40.1235V40.2404H42.1005V40.1235H34.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 35.9471V36.0641H42.1003V35.9471H34.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 26.5935L42.1005 32.594L41.1041 33.5996H35.0969L34.1005 32.594L34.1003 26.5935L35.0967 25.5996H41.104L42.1003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 31.6235V31.7404L42.1005 31.7404V31.6235L34.1005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 27.4471V27.5641L42.1003 27.5641V27.4471L34.1003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 18.0935L42.1005 24.094L41.1041 25.0996H35.0969L34.1005 24.094L34.1003 18.0935L35.0967 17.0996H41.104L42.1003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 23.1235V23.2404L42.1005 23.2404V23.1235L34.1005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 18.9471V19.0641L42.1003 19.0641V18.9471L34.1003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 9.59353L42.1005 15.594L41.1041 16.5996H35.0969L34.1005 15.594L34.1003 9.59353L35.0967 8.59961L41.104 8.59961L42.1003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 14.6235V14.7404L42.1005 14.7404V14.6235L34.1005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 10.4471V10.5641L42.1003 10.5641V10.4471L34.1003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1003 1.09353L42.1005 7.094L41.1041 8.09961L35.0969 8.09961L34.1005 7.094L34.1003 1.09353L35.0967 0.0996098L41.104 0.0996099L42.1003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1005 6.12346V6.2404L42.1005 6.2404V6.12346L34.1005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1003 1.94713V2.06406L42.1003 2.06406V1.94713L34.1003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 43.5935L50.6005 49.594L49.6041 50.5996H43.5969L42.6005 49.594L42.6003 43.5935L43.5967 42.5996H49.6039L50.6003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 48.6235V48.7404L50.6005 48.7404V48.6235L42.6005 48.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 44.4471V44.5641L50.6003 44.5641V44.4471L42.6003 44.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 35.0935L50.6005 41.094L49.6041 42.0996H43.5969L42.6005 41.094L42.6003 35.0935L43.5967 34.0996H49.6039L50.6003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 40.1235V40.2404L50.6005 40.2404V40.1235L42.6005 40.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 35.9471V36.0641L50.6003 36.0641V35.9471L42.6003 35.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 26.5935L50.6005 32.594L49.6041 33.5996H43.5969L42.6005 32.594L42.6003 26.5935L43.5967 25.5996L49.6039 25.5996L50.6003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 31.6235V31.7404L50.6005 31.7404V31.6235L42.6005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 27.4471V27.5641L50.6003 27.5641V27.4471L42.6003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 18.0935L50.6005 24.094L49.6041 25.0996L43.5969 25.0996L42.6005 24.094L42.6003 18.0935L43.5967 17.0996L49.6039 17.0996L50.6003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 23.1235V23.2404L50.6005 23.2404V23.1235L42.6005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 18.9471V19.0641L50.6003 19.0641V18.9471L42.6003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 9.59353L50.6005 15.594L49.6041 16.5996L43.5969 16.5996L42.6005 15.594L42.6003 9.59353L43.5967 8.59961L49.6039 8.59961L50.6003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 14.6235V14.7404L50.6005 14.7404V14.6235L42.6005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 10.4471V10.5641L50.6003 10.5641V10.4471L42.6003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6003 1.09353L50.6005 7.094L49.6041 8.09961L43.5969 8.09961L42.6005 7.094L42.6003 1.09353L43.5967 0.0996099L49.6039 0.09961L50.6003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6005 6.12346V6.2404L50.6005 6.2404V6.12346L42.6005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 1.94713V2.06406L50.6003 2.06406V1.94713L42.6003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 43.5935L59.1005 49.594L58.1041 50.5996H52.0969L51.1005 49.594L51.1003 43.5935L52.0967 42.5996H58.1039L59.1003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 48.6235V48.7404H59.1005V48.6235H51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 44.4471V44.5641H59.1003V44.4471H51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 35.0935L59.1005 41.094L58.1041 42.0996H52.0969L51.1005 41.094L51.1003 35.0935L52.0967 34.0996H58.1039L59.1003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 40.1235V40.2404H59.1005V40.1235H51.1005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 35.9471V36.0641H59.1003V35.9471H51.1003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 26.5935L59.1005 32.594L58.1041 33.5996H52.0969L51.1005 32.594L51.1003 26.5935L52.0967 25.5996L58.1039 25.5996L59.1003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 31.6235V31.7404L59.1005 31.7404V31.6235L51.1005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 27.4471V27.5641L59.1003 27.5641V27.4471L51.1003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 18.0935L59.1005 24.094L58.1041 25.0996L52.0969 25.0996L51.1005 24.094L51.1003 18.0935L52.0967 17.0996L58.1039 17.0996L59.1003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 23.1235V23.2404L59.1005 23.2404V23.1235L51.1005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 18.9471V19.0641L59.1003 19.0641V18.9471L51.1003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 9.59353L59.1005 15.594L58.1041 16.5996L52.0969 16.5996L51.1005 15.594L51.1003 9.59353L52.0967 8.59961L58.1039 8.59961L59.1003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 14.6235V14.7404L59.1005 14.7404V14.6235L51.1005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 10.4471V10.5641L59.1003 10.5641V10.4471L51.1003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1003 1.09353L59.1005 7.094L58.1041 8.09961L52.0969 8.09961L51.1005 7.094L51.1003 1.09353L52.0967 0.09961L58.1039 0.0996101L59.1003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1005 6.12346V6.2404L59.1005 6.2404V6.12346L51.1005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1003 1.94713V2.06406L59.1003 2.06406V1.94713L51.1003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 43.5935L67.6005 49.594L66.6041 50.5996H60.5969L59.6005 49.594L59.6003 43.5935L60.5967 42.5996H66.604L67.6003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 48.6235V48.7404H67.6005V48.6235H59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 44.4471V44.5641H67.6003V44.4471H59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 35.0935L67.6005 41.094L66.6041 42.0996H60.5969L59.6005 41.094L59.6003 35.0935L60.5967 34.0996H66.604L67.6003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 40.1235V40.2404H67.6005V40.1235H59.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 35.9471V36.0641H67.6003V35.9471H59.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 26.5935L67.6005 32.594L66.6041 33.5996H60.5969L59.6005 32.594L59.6003 26.5935L60.5967 25.5996L66.604 25.5996L67.6003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 31.6235V31.7404L67.6005 31.7404V31.6235L59.6005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 27.4471V27.5641L67.6003 27.5641V27.4471L59.6003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 18.0935L67.6005 24.094L66.6041 25.0996L60.5969 25.0996L59.6005 24.094L59.6003 18.0935L60.5967 17.0996L66.604 17.0996L67.6003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 23.1235V23.2404L67.6005 23.2404V23.1235L59.6005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 18.9471V19.0641L67.6003 19.0641V18.9471L59.6003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 9.59353L67.6005 15.594L66.6041 16.5996L60.5969 16.5996L59.6005 15.594L59.6003 9.59353L60.5967 8.59961L66.604 8.59961L67.6003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 14.6235V14.7404L67.6005 14.7404V14.6235L59.6005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 10.4471V10.5641L67.6003 10.5641V10.4471L59.6003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6003 1.09353L67.6005 7.094L66.6041 8.09961L60.5969 8.09961L59.6005 7.094L59.6003 1.09353L60.5967 0.0996101L66.604 0.0996102L67.6003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6005 6.12346V6.2404L67.6005 6.2404V6.12346L59.6005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6003 1.94713V2.06406L67.6003 2.06406V1.94713L59.6003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 43.5935L76.1005 49.594L75.1041 50.5996L69.0969 50.5996L68.1005 49.594L68.1003 43.5935L69.0967 42.5996L75.104 42.5996L76.1003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 48.6235V48.7404L76.1005 48.7404V48.6235L68.1005 48.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 44.4471V44.5641L76.1003 44.5641V44.4471L68.1003 44.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 35.0935L76.1005 41.094L75.1041 42.0996L69.0969 42.0996L68.1005 41.094L68.1003 35.0935L69.0967 34.0996L75.104 34.0996L76.1003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 40.1235V40.2404L76.1005 40.2404V40.1235L68.1005 40.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 35.9471V36.0641L76.1003 36.0641V35.9471L68.1003 35.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 26.5935L76.1005 32.594L75.1041 33.5996L69.0969 33.5996L68.1005 32.594L68.1003 26.5935L69.0967 25.5996L75.104 25.5996L76.1003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 31.6235V31.7404L76.1005 31.7404V31.6235L68.1005 31.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 27.4471V27.5641L76.1003 27.5641V27.4471L68.1003 27.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 18.0935L76.1005 24.094L75.1041 25.0996L69.0969 25.0996L68.1005 24.094L68.1003 18.0935L69.0967 17.0996L75.104 17.0996L76.1003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 23.1235V23.2404L76.1005 23.2404V23.1235L68.1005 23.1235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 18.9471V19.0641L76.1003 19.0641V18.9471L68.1003 18.9471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 9.59353L76.1005 15.594L75.1041 16.5996L69.0969 16.5996L68.1005 15.594L68.1003 9.59353L69.0967 8.59961L75.104 8.59961L76.1003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 14.6235V14.7404L76.1005 14.7404V14.6235L68.1005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 10.4471V10.5641L76.1003 10.5641V10.4471L68.1003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1003 1.09353L76.1005 7.094L75.1041 8.09961L69.0969 8.09961L68.1005 7.094L68.1003 1.09353L69.0967 0.0996102L75.104 0.0996103L76.1003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1005 6.12346V6.2404L76.1005 6.2404V6.12346L68.1005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1003 1.94713V2.06406L76.1003 2.06406V1.94713L68.1003 1.94713Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 43.5935L84.6005 49.594L83.6041 50.5996H77.5969L76.6005 49.594L76.6003 43.5935L77.5967 42.5996H83.604L84.6003 43.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 48.6235V48.7404H84.6005V48.6235H76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 44.4471V44.5641H84.6003V44.4471H76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 35.0935L84.6005 41.094L83.6041 42.0996H77.5969L76.6005 41.094L76.6003 35.0935L77.5967 34.0996H83.604L84.6003 35.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 40.1235V40.2404H84.6005V40.1235H76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 35.9471V36.0641H84.6003V35.9471H76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 26.5935L84.6005 32.594L83.6041 33.5996H77.5969L76.6005 32.594L76.6003 26.5935L77.5967 25.5996H83.604L84.6003 26.5935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 31.6235V31.7404H84.6005V31.6235H76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 27.4471V27.5641H84.6003V27.4471H76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 18.0935L84.6005 24.094L83.6041 25.0996H77.5969L76.6005 24.094L76.6003 18.0935L77.5967 17.0996H83.604L84.6003 18.0935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 23.1235V23.2404H84.6005V23.1235H76.6005Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 18.9471V19.0641H84.6003V18.9471H76.6003Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 9.59353L84.6005 15.594L83.6041 16.5996H77.5969L76.6005 15.594L76.6003 9.59353L77.5967 8.59961L83.604 8.59961L84.6003 9.59353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 14.6235V14.7404L84.6005 14.7404V14.6235L76.6005 14.6235Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 10.4471V10.5641L84.6003 10.5641V10.4471L76.6003 10.4471Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6003 1.09353L84.6005 7.094L83.6041 8.09961L77.5969 8.09961L76.6005 7.094L76.6003 1.09353L77.5967 0.0996103L83.604 0.0996104L84.6003 1.09353Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6005 6.12346V6.2404L84.6005 6.2404V6.12346L76.6005 6.12346Z",
    fill: "#C9D1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6003 1.94713V2.06406L84.6003 2.06406V1.94713L76.6003 1.94713Z",
    fill: "#C9D1E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_382_1915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.5,
    height: 84.5,
    fill: "white",
    transform: "translate(0.100098 50.6001) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotovoltaiquePanelH);
export default __webpack_public_path__ + "static/media/icon-photovoltaique-panel-h.6d067210034d8e1eefe487f50c23f48c.svg";
export { ForwardRef as ReactComponent };